import url from './url';



export default url(({ searchParams }) => `/presets${searchParams ? `?${searchParams}` : ''}`);
